// Fase 8 · Módulo /app/frota + widget dashboard — bilingüe GL/ES
import i18n from "@/i18n";

const GL = {
  frota: {
    nav: "Frota",
    title: "Panel de flota institucional",
    subtitle: "Vehículos operativos da Mancomunidade do Salnés · datos oficiais Valoriza (agosto 2026)",
    kpi_total: "Vehículos",
    kpi_gps: "Con telemetría GPS",
    kpi_iris: "Sen GPS (IRIS)",
    kpi_avg_age: "Idade media",
    kpi_euro6: "% Euro 6+",
    kpi_ytd_km: "km percorridos AAA",
    kpi_ytd_co2: "kg CO₂e AAA",
    filters_all: "Todos",
    filter_type: "Tipo",
    filter_fuel: "Combustible",
    filter_gps: "GPS",
    filter_gps_active: "Con GPS activo",
    filter_gps_none: "Sen GPS",
    type_recogida: "Recollida",
    type_barrido: "Varrido",
    type_lavado: "Lavado contedores",
    type_grua: "Grúa",
    type_furgoneta: "Furgoneta",
    type_inspeccion: "Inspección",
    type_outro: "Outro",
    fuel_diesel_b7: "Diésel B7",
    fuel_glp_autogas: "GLP autogás",
    fuel_gnc_gnv: "GNC / GNV",
    fuel_gasolina_e10: "Gasolina E10",
    fuel_hvo_biocombustible: "HVO biocombustible",
    fuel_electricidade_mix_es_2024: "Eléctrico",
    card_year: "Ano",
    card_euro: "Emisións",
    card_type: "Tipo",
    card_fuel: "Combustible",
    card_gps_on: "GPS activo",
    card_gps_off: "IRIS · sen GPS",
    card_photo_alt: "Silueta institucional do vehículo",
    detail_title: "Ficha técnica",
    detail_matriculacion: "Data matriculación",
    detail_categoria: "Categoría DGT",
    detail_etiqueta: "Etiqueta DGT",
    detail_centro: "Centro asignado",
    detail_grupo: "Grupo Valoriza",
    detail_km_dia: "Km / día (media)",
    detail_annual_km: "Km anuais estimados",
    detail_consumption: "Consumo medio l/km",
    detail_provisional: "Estimación provisional",
    detail_last_calc: "Último cálculo huella",
    detail_km_24h: "Km últimas 24 h",
    detail_activity_series: "Actividade últimos 30 días",
    detail_trajectory: "Traxectoria GPS 24 h",
    detail_no_gps: "Este vehículo non transmite GPS. Cálculo baseado en km medios estimados.",
    detail_download_pdf: "Descargar ficha PDF",
    close: "Pechar",
    empty: "Aínda non hai vehículos importados. Contacta co administrador.",
  },
  dashboard_widget: {
    fleet_title: "Estado de flota",
    fleet_active: "vehículos activos",
    fleet_km_24h: "km últimas 24 h",
    fleet_stale_alert: "{{n}} vehículos GPS sen transmitir hai máis de 48 h",
    fleet_link: "Ver panel de flota",
    fleet_no_alerts: "Toda a flota GPS transmite correctamente.",
  },
  frota_impacto: {
    section_kicker: "FLOTA EN OPERACIÓN",
    section_title: "Frota institucional",
    section_sub: "Datos oficiais Valoriza · Mancomunidade do Salnés",
    total_vehicles: "Vehículos totais",
    gps_tracked: "Con telemetría GPS",
    avg_age: "Idade media (anos)",
    euro6_pct: "% Euro 6 ou superior",
    ytd_emissions: "Emisións anuais estimadas",
    by_type: "Distribución por tipo",
    by_fuel: "Distribución por combustible",
  },
};

const ES = {
  frota: {
    nav: "Flota",
    title: "Panel de flota institucional",
    subtitle: "Vehículos operativos de la Mancomunidad do Salnés · datos oficiales Valoriza (agosto 2026)",
    kpi_total: "Vehículos",
    kpi_gps: "Con telemetría GPS",
    kpi_iris: "Sin GPS (IRIS)",
    kpi_avg_age: "Antigüedad media",
    kpi_euro6: "% Euro 6+",
    kpi_ytd_km: "km recorridos YTD",
    kpi_ytd_co2: "kg CO₂e YTD",
    filters_all: "Todos",
    filter_type: "Tipo",
    filter_fuel: "Combustible",
    filter_gps: "GPS",
    filter_gps_active: "Con GPS activo",
    filter_gps_none: "Sin GPS",
    type_recogida: "Recogida",
    type_barrido: "Barrido",
    type_lavado: "Lavado contenedores",
    type_grua: "Grúa",
    type_furgoneta: "Furgoneta",
    type_inspeccion: "Inspección",
    type_outro: "Otro",
    fuel_diesel_b7: "Diésel B7",
    fuel_glp_autogas: "GLP autogas",
    fuel_gnc_gnv: "GNC / GNV",
    fuel_gasolina_e10: "Gasolina E10",
    fuel_hvo_biocombustible: "HVO biocombustible",
    fuel_electricidade_mix_es_2024: "Eléctrico",
    card_year: "Año",
    card_euro: "Emisiones",
    card_type: "Tipo",
    card_fuel: "Combustible",
    card_gps_on: "GPS activo",
    card_gps_off: "IRIS · sin GPS",
    card_photo_alt: "Silueta institucional del vehículo",
    detail_title: "Ficha técnica",
    detail_matriculacion: "Fecha matriculación",
    detail_categoria: "Categoría DGT",
    detail_etiqueta: "Etiqueta DGT",
    detail_centro: "Centro asignado",
    detail_grupo: "Grupo Valoriza",
    detail_km_dia: "Km / día (media)",
    detail_annual_km: "Km anuales estimados",
    detail_consumption: "Consumo medio l/km",
    detail_provisional: "Estimación provisional",
    detail_last_calc: "Último cálculo huella",
    detail_km_24h: "Km últimas 24 h",
    detail_activity_series: "Actividad últimos 30 días",
    detail_trajectory: "Trayectoria GPS 24 h",
    detail_no_gps: "Este vehículo no transmite GPS. Cálculo basado en km medios estimados.",
    detail_download_pdf: "Descargar ficha PDF",
    close: "Cerrar",
    empty: "Aún no hay vehículos importados. Contacta con el administrador.",
  },
  dashboard_widget: {
    fleet_title: "Estado de flota",
    fleet_active: "vehículos activos",
    fleet_km_24h: "km últimas 24 h",
    fleet_stale_alert: "{{n}} vehículos GPS sin transmitir en más de 48 h",
    fleet_link: "Ver panel de flota",
    fleet_no_alerts: "Toda la flota GPS transmite correctamente.",
  },
  frota_impacto: {
    section_kicker: "FLOTA EN OPERACIÓN",
    section_title: "Flota institucional",
    section_sub: "Datos oficiales Valoriza · Mancomunidad do Salnés",
    total_vehicles: "Vehículos totales",
    gps_tracked: "Con telemetría GPS",
    avg_age: "Antigüedad media (años)",
    euro6_pct: "% Euro 6 o superior",
    ytd_emissions: "Emisiones anuales estimadas",
    by_type: "Distribución por tipo",
    by_fuel: "Distribución por combustible",
  },
};

i18n.addResourceBundle("gl", "common", { fase8: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase8: ES }, true, true);

export default {};
